import { apiClient } from './client';

export interface OnboardingStep {
  name: string;
  status: 'done' | 'skipped' | 'failed' | 'not_run';
  detail: string;
}

export interface MirrorOnboardingResult {
  warnings: string[];
  steps: OnboardingStep[];
}

export interface MirrorOnboardingSummary {
  templateFirmId: number;
  templateFirmName: string;
  reportCount: number;
  widgetCount: number;
  cdcTableCount: number;
}

export const mirrorOnboardingApi = {
  summary: async (firmId: number): Promise<MirrorOnboardingSummary> => {
    const response = await apiClient.get(`/api/admin/firms/${firmId}/mirror-onboarding/summary`);
    return response.data;
  },
  run: async (firmId: number): Promise<MirrorOnboardingResult> => {
    const response = await apiClient.post(`/api/admin/firms/${firmId}/mirror-onboarding`);
    return response.data;
  },
};
